import InfoIcon from '@mui/icons-material/Info';
import { Alert, AlertTitle, Tooltip } from '@mui/material';
import { useAppSelector } from '../../hooks';

interface PscInspectionRiskMonthProps {
    monthIndex: 0 | 1 | 2;
}
const PscInspectionRiskMonth = ({ monthIndex }: PscInspectionRiskMonthProps) => {
    const mouData = useAppSelector((state) => state.MOURisk.List);

    // Convert mouData dictionary to an array of its values
    const valuesArray = Object.values(mouData);

    // Find the first entry with a non-empty InspectionWindow
    const mouRisk = valuesArray.find((value) => value?.MOURisk?.find((f) => f.InspectionWindow.length > 0));

    if (mouRisk && mouRisk.MOURisk) {
        return (
            <div>
                <Tooltip
                    title={
                        <Alert severity="info">
                            <AlertTitle>Inspection Risk</AlertTitle>
                            <div>
                                <span>
                                    <strong>Blue</strong> = Non Priority Vessel (Low Risk).
                                </span>
                            </div>
                            <div>
                                <span>
                                    <strong>Yellow</strong> = Vessel may be inspected (Medium Risk).
                                </span>
                            </div>
                            <div>
                                <span>
                                    <strong>Red</strong> = Vessel must be inspected (High Risk).
                                </span>
                            </div>
                        </Alert>
                    }
                    placement="left"
                    arrow
                >
                    <span>
                        {mouRisk?.MOURisk[0].InspectionWindow[monthIndex].Month} &nbsp;
                        <InfoIcon />
                    </span>
                </Tooltip>
            </div>
        );
    } else {
        return <div>Month {`${monthIndex + 1}`}</div>;
    }
};

export default PscInspectionRiskMonth;
